import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../../../Layouts/Shared/_PublicLayout';

// Slayt konfigürasyonu — metinler i18n anahtarıyla çevrilir
const SLAYT_KONFIG = [
  {
    id: 1,
    anahtarBaslik: 'public.static.home-page.slide1.title',
    anahtarAcik: 'public.static.home-page.slide1.desc',
    anahtarButon: 'public.static.home-page.slide1.btn',
    butonLink: '/portal/login',
    arkaplan: 'linear-gradient(135deg, #e6e6e6 0%, #ffffff 100%)',
  },
  {
    id: 2,
    anahtarBaslik: 'public.static.home-page.slide2.title',
    anahtarAcik: 'public.static.home-page.slide2.desc',
    anahtarButon: 'public.static.home-page.slide2.btn',
    butonLink: '/contact',
    arkaplan: 'linear-gradient(135deg, #d1e4f3 0%, #ffffff 100%)',
  },
];

// Hızlı erişim bağlantıları
const HIZLI_ERISIM_KONFIG = [
  { anahtarAd: 'public.static.home-page.quick.identity', ikon: 'fa-user-shield', link: '#' },
  { anahtarAd: 'public.static.home-page.quick.database', ikon: 'fa-database', link: '#' },
  { anahtarAd: 'public.static.home-page.quick.messaging', ikon: 'fa-envelope-open-text', link: '#' },
  { anahtarAd: 'public.static.home-page.quick.storage', ikon: 'fa-hdd', link: '#' },
  { anahtarAd: 'public.static.home-page.quick.security', ikon: 'fa-shield-virus', link: '#' },
  { anahtarAd: 'public.static.home-page.quick.network', ikon: 'fa-network-wired', link: '#' },
];

// Öne çıkan servis kartları
const KART_KONFIG = [
  { anahtarBaslik: 'public.static.home-page.card.tatalli-corvia.title', anahtarAcik: 'public.static.home-page.card.tatalli-corvia.desc', ikon: 'fa-user-lock' },
  { anahtarBaslik: 'public.static.home-page.card.cloud-instance.title', anahtarAcik: 'public.static.home-page.card.cloud-instance.desc', ikon: 'fa-database' },
  { anahtarBaslik: 'public.static.home-page.card.enterprise-support.title', anahtarAcik: 'public.static.home-page.card.enterprise-support.desc', ikon: 'fa-headset' },
];

export default function AnaSayfa() {
  const { t } = useTranslation();
  const [aktifSlayt, setAktifSlayt] = useState(0);
  const [duraklatildi, setDuraklatildi] = useState(false);

  // Otomatik slayt geçişi — duraklatıldığında interval temizlenir
  useEffect(() => {
    if (duraklatildi) return;
    const zamanlayici = setInterval(() => {
      setAktifSlayt(onceki => (onceki === SLAYT_KONFIG.length - 1 ? 0 : onceki + 1));
    }, 5000);
    return () => clearInterval(zamanlayici);
  }, [duraklatildi]);

  return (
    <PublicLayout title={t('public.static.home-page.slide1.title')}>
      {/*
        Sayfa-özgü stiller — yalnızca bu sayfaya ait class'lar burada tanımlı.
        Global utility'ler (pl-container, pl-btn, vb.) _PublicLayout'tan gelir.
      */}
      <style>{`
        /* ── Slayt gösterisi ── */
        .hp-slayt-kap {
          position: relative;
          background: #f3f4f6;
          overflow: hidden;
          min-height: 580px;
        }
        .hp-slayt {
          display: none;
          align-items: center;
          min-height: 580px;
          animation: hp-solIn 0.7s ease;
        }
        .hp-slayt.aktif { display: flex; }

        @keyframes hp-solIn {
          from { opacity: 0.4; transform: translateX(12px); }
          to   { opacity: 1;   transform: translateX(0);    }
        }

        .hp-slayt-icerik {
          position: relative;
          z-index: 10;
          max-width: 580px;
          padding: 80px 0;
        }
        .hp-slayt-icerik h1 {
          font-size: clamp(26px, 3.5vw, 42px);
          font-weight: 700;
          margin: 0 0 18px;
          line-height: 1.25;
          color: #111;
        }
        .hp-slayt-icerik p {
          font-size: 17px;
          margin: 0 0 32px;
          color: #444;
          line-height: 1.65;
        }
        .hp-arka-sekil {
          position: absolute;
          right: 0; top: 0; bottom: 0;
          width: 58%;
          clip-path: polygon(18% 0%, 100% 0%, 100% 100%, 0% 100%);
          z-index: 1;
          pointer-events: none;
        }

        /* ── Slayt navigasyon ── */
        .hp-slayt-nav {
          position: absolute;
          bottom: 24px; left: 50%;
          transform: translateX(-50%);
          display: flex; align-items: center; gap: 12px;
          z-index: 20;
        }
        .hp-nav-nokta {
          width: 10px; height: 10px;
          border: 2px solid #555; border-radius: 50%;
          cursor: pointer; padding: 0; background: transparent;
          transition: background 0.2s, border-color 0.2s;
        }
        .hp-nav-nokta.aktif { background: #111; border-color: #111; }
        .hp-duraklat-btn {
          background: transparent; border: none; cursor: pointer;
          font-size: 13px; color: #555; padding: 4px 6px;
          border-radius: 4px; transition: color 0.2s;
        }
        .hp-duraklat-btn:hover { color: #111; }

        /* ── Hızlı erişim ── */
        .hp-hizli-sarici {
          border-bottom: 1px solid var(--pl-border);
          background: #fff;
        }
        .hp-hizli-grid {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
        }
        .hp-hizli-oge {
          text-align: center;
          color: #2f2f2f;
          text-decoration: none;
          transition: background 0.2s, color 0.2s;
          display: flex; flex-direction: column; align-items: center;
          padding: 32px 36px; gap: 12px;
          border-right: 1px solid var(--pl-border);
          min-width: 120px;
        }
        .hp-hizli-oge:first-child { border-left: 1px solid var(--pl-border); }
        .hp-hizli-oge:hover { background: #f0f7ff; color: var(--pl-primary); }
        .hp-hizli-oge span { font-weight: 600; font-size: 13px; letter-spacing: 0.02em; }

        /* ── Servis kartları ── */
        .hp-kart-izgara {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 28px;
        }
        .hp-kart {
          background: #fff;
          border: 1px solid var(--pl-border);
          border-radius: var(--pl-radius);
          overflow: hidden;
          transition: box-shadow 0.25s, transform 0.25s;
          display: flex; flex-direction: column;
        }
        .hp-kart:hover {
          box-shadow: 0 12px 32px rgba(0,0,0,0.1);
          transform: translateY(-3px);
        }
        .hp-kart-gorsel {
          height: 180px;
          background: linear-gradient(145deg, #eef4fb, #dce9f7);
          display: flex; align-items: center; justify-content: center;
          font-size: 56px; color: var(--pl-primary);
        }
        .hp-kart-govde {
          padding: 28px 28px 32px;
          display: flex; flex-direction: column; flex: 1;
        }
        .hp-kart-govde h3 {
          font-size: 20px; font-weight: 700;
          margin: 0 0 10px; color: #111;
        }
        .hp-kart-govde p {
          color: var(--pl-muted); font-size: 14px;
          margin: 0 0 20px; flex: 1; line-height: 1.65;
        }
        .hp-btn-link {
          display: inline-flex; align-items: center; gap: 6px;
          color: var(--pl-primary); background: transparent;
          border: none; cursor: pointer;
          font-weight: 700; font-size: 14px;
          text-decoration: none; padding: 0;
        }
        .hp-btn-link:hover { text-decoration: underline; }

        /* ── Tanıtım şeridi ── */
        .hp-serit {
          background: linear-gradient(110deg, #013682 0%, #014199 60%, #014aad 100%);
          color: #fff;
          padding: 64px 0;
        }
        .hp-serit-ic {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 28px;
        }
        .hp-serit-ic h2 {
          font-size: 26px; font-weight: 700;
          margin: 0 0 10px; line-height: 1.3;
        }
        .hp-serit-ic p {
          font-size: 15px; opacity: 0.88;
          margin: 0; line-height: 1.65;
        }
        .hp-btn-beyaz {
          background: #fff;
          color: var(--pl-primary);
          font-weight: 700;
          flex-shrink: 0;
          box-shadow: 0 4px 14px rgba(0,0,0,0.15);
        }
        .hp-btn-beyaz:hover { background: #eef4fb; transform: translateY(-1px); }

        /* ── Sosyal çubuk ── */
        .hp-sosyal {
          padding: 28px 0;
          border-top: 1px solid var(--pl-border);
          background: #fafafa;
        }
        .hp-sosyal-ic { display: flex; align-items: center; gap: 20px; }
        .hp-sosyal-etiket {
          font-size: 13px; color: var(--pl-muted);
          font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase;
        }
        .hp-sosyal-ikon {
          font-size: 20px; color: var(--pl-muted);
          cursor: pointer; transition: color 0.2s, transform 0.2s;
        }
        .hp-sosyal-ikon:hover { color: var(--pl-primary); transform: translateY(-2px); }

        /* ════════════════════════════════════
           DUYARLI TASARIM
        ════════════════════════════════════ */

        /* ≤1024px: Tablet yatay */
        @media (max-width: 1024px) {
          .hp-slayt-kap, .hp-slayt { min-height: 500px; }
          .hp-slayt-icerik { padding: 60px 0; max-width: 480px; }
          .hp-hizli-oge    { padding: 26px 20px; }
          .hp-kart-izgara  { grid-template-columns: repeat(2, 1fr); }
        }

        /* ≤768px: Tablet dikey / büyük telefon */
        @media (max-width: 768px) {
          .hp-slayt-kap, .hp-slayt { min-height: auto; }
          .hp-slayt        { flex-direction: column; align-items: flex-start; }
          .hp-slayt-icerik { padding: 48px 0 68px; max-width: 100%; }
          .hp-arka-sekil   { display: none; }

          .hp-hizli-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
          }
          .hp-hizli-oge {
            border-right: none;
            border-bottom: 1px solid var(--pl-border);
            padding: 22px 12px;
            min-width: unset;
            width: 100%;
          }
          .hp-hizli-oge:first-child { border-left: none; }

          .hp-kart-izgara { grid-template-columns: 1fr; gap: 20px; }

          .hp-serit       { padding: 48px 0; }
          .hp-serit-ic    { flex-direction: column; align-items: flex-start; gap: 24px; }
          .hp-serit-ic h2 { font-size: 22px; }
          .hp-btn-beyaz   { width: 100%; justify-content: center; }
        }

        /* ≤480px: Küçük telefon */
        @media (max-width: 480px) {
          .hp-slayt-icerik    { padding: 40px 0 64px; }
          .hp-slayt-icerik h1 { font-size: 22px; }
          .hp-slayt-icerik p  { font-size: 15px; }
          /* Slayt CTA butonunu tam genişliğe al */
          .hp-slayt-icerik .pl-btn { width: 100%; justify-content: center; }

          .hp-slayt-nav { bottom: 16px; gap: 10px; }
          .hp-nav-nokta { width: 9px; height: 9px; }

          .hp-hizli-grid { grid-template-columns: repeat(2, 1fr); }
          .hp-hizli-oge  { padding: 20px 10px; }
          .hp-hizli-oge span { font-size: 12px; }

          .hp-kart-gorsel { height: 150px; font-size: 44px; }
          .hp-kart-govde  { padding: 20px 20px 24px; }

          .hp-serit       { padding: 40px 0; }
          .hp-serit-ic h2 { font-size: 20px; }
          .hp-serit-ic p  { font-size: 14px; }
          .hp-sosyal      { padding: 22px 0; }
        }
      `}</style>

      {/* ══════════ SLAYT GÖSTERİSİ ══════════ */}
      <section className="hp-slayt-kap" aria-label="Ana Banner">
        {SLAYT_KONFIG.map((slayt, indeks) => (
          <div key={slayt.id} className={`hp-slayt${indeks === aktifSlayt ? ' aktif' : ''}`}>
            <div className="hp-arka-sekil" style={{ background: slayt.arkaplan }} />
            <div className="pl-container" style={{ width: '100%', position: 'relative', zIndex: 10 }}>
              <div className="hp-slayt-icerik">
                <h1>{t(slayt.anahtarBaslik)}</h1>
                <p>{t(slayt.anahtarAcik)}</p>
                <Link to={slayt.butonLink} className="pl-btn pl-btn-primary">
                  {t(slayt.anahtarButon)}
                  <i className="fas fa-arrow-right" style={{ fontSize: 13 }} />
                </Link>
              </div>
            </div>
          </div>
        ))}

        <div className="hp-slayt-nav">
          <button
            className="hp-duraklat-btn"
            onClick={() => setDuraklatildi(p => !p)}
            aria-label={duraklatildi ? 'Slaytı oynat' : 'Slaytı duraklat'}
          >
            <i className={`fas ${duraklatildi ? 'fa-play' : 'fa-pause'}`} />
          </button>
          {SLAYT_KONFIG.map((_, i) => (
            <button
              key={i}
              className={`hp-nav-nokta${i === aktifSlayt ? ' aktif' : ''}`}
              onClick={() => setAktifSlayt(i)}
              aria-label={`${i + 1}. slayta git`}
            />
          ))}
        </div>
      </section>

      {/* ══════════ HIZLI ERİŞİM ══════════ */}
      <section className="hp-hizli-sarici">
        <div className="pl-container">
          <div className="hp-hizli-grid">
            {HIZLI_ERISIM_KONFIG.map((oge, i) => (
              <Link key={i} to={oge.link} className="hp-hizli-oge">
                <i className={`fas ${oge.ikon}`} style={{ fontSize: 26, color: 'var(--pl-primary)' }} />
                <span>{t(oge.anahtarAd)}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ ÖNE ÇIKAN SERVİSLER ══════════ */}
      <section style={{ padding: '72px 0 88px', background: '#fafafa' }}>
        <div className="pl-container">
          <p style={{ margin: '0 0 6px', textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: 12, fontWeight: 700, color: 'var(--pl-primary)' }}>
            {t('public.static.home-page.section.services.tag')}
          </p>
          <h2 style={{ fontSize: 26, fontWeight: 700, color: '#111', margin: '0 0 8px' }}>
            {t('public.static.home-page.section.services.title')}
          </h2>
          <p style={{ fontSize: 15, color: 'var(--pl-muted)', margin: '0 0 40px' }}>
            {t('public.static.home-page.section.services.desc')}
          </p>
          <div className="hp-kart-izgara">
            {KART_KONFIG.map((kart, i) => (
              <article key={i} className="hp-kart">
                <div className="hp-kart-gorsel">
                  <i className={`fas ${kart.ikon}`} />
                </div>
                <div className="hp-kart-govde">
                  <h3>{t(kart.anahtarBaslik)}</h3>
                  <p>{t(kart.anahtarAcik)}</p>
                  <Link to="#" className="hp-btn-link">
                    {t('public.static.home-page.card.learn-more')}
                    <i className="fas fa-chevron-right" style={{ fontSize: 10 }} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ TANITIM ŞERİDİ ══════════ */}
      <section className="hp-serit">
        <div className="pl-container">
          <div className="hp-serit-ic">
            <div>
              <h2>{t('public.static.home-page.strip.title')}</h2>
              <p>{t('public.static.home-page.strip.desc')}</p>
            </div>
            <Link to="/contact" className="pl-btn hp-btn-beyaz">
              {t('public.static.home-page.strip.cta')}
              <i className="fas fa-arrow-right" style={{ fontSize: 13 }} />
            </Link>
          </div>
        </div>
      </section>

      {/* ══════════ SOSYAL MEDYA ÇUBUĞU ══════════ */}
      <section className="hp-sosyal">
        <div className="pl-container">
          <div className="hp-sosyal-ic">
            <span className="hp-sosyal-etiket">{t('public.static.home-page.social.follow')}</span>
            <div style={{ display: 'flex', gap: 18 }}>
              <a href="https://www.linkedin.com/company/tatalli" target="_blank">
                <i className="fab fa-linkedin hp-sosyal-ikon" />
              </a>
              <i className="fab fa-github   hp-sosyal-ikon d-none" />
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
